import type { RootState } from "../types";
import { acceptableDocumentEntityAdapter } from "./adapter";

export const {
    selectAll: selectAllAcceptableDocuments,
    selectById: selectAcceptableDocumentById,
} = acceptableDocumentEntityAdapter.getSelectors<RootState>((state) => state.acceptableDocuments);